<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch03">
<a id="page3">
<div class="chapterHead">
<h2 class="chapterTitle"> </h2></div>
<div class="chapterBody">
<p class="chapterOpenerText"><span class="chapterOpenerFirstWords"><span class="bold">It never fails to amaze me.</span></span></p>
<p class="paraCenter">Create a paradise out of the ether. Throw in some wildlife, volcanoes, and windstorms. Some iguanas, koalas, and waterfalls. Come back a few billion years later, and just when it looks like the whole place is going to implode—with pollution, disease, and war; famine, fatigue, and fright—there are still those who see the beauty. Who act with kindness. And who live with hope and gratitude.</p>
<p class="spaceBreak"> </p>
<p class="paraCenter">Actually, they carry the entire planet. Who’d have thunk?</p>
<p class="spaceBreak"> </p>
<p class="paraCenter"><em class="italic">Yeah, okay. Guilty.</em></p>
</div>
</a></div><a id="page3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416594161_ch03.vue?31a44e66